import AppBar from 'material-ui/AppBar'
import Card from 'material-ui/Card/Card'
import Checkbox from 'material-ui/Checkbox'
import CircularProgress from 'material-ui/CircularProgress'
import RaisedButton from 'material-ui/RaisedButton'
import AlertError from 'material-ui/svg-icons/alert/error'
import ContentAdd from 'material-ui/svg-icons/content/add'
import FileFileDownload from 'material-ui/svg-icons/file/file-download'
import NotificationSync from 'material-ui/svg-icons/notification/sync'
import Table from 'material-ui/Table/Table'
import TableBody from 'material-ui/Table/TableBody'
import TableHeader from 'material-ui/Table/TableHeader'
import TableHeaderColumn from 'material-ui/Table/TableHeaderColumn'
import TableRow from 'material-ui/Table/TableRow'
import TableRowColumn from 'material-ui/Table/TableRowColumn'
import * as R from 'ramda'
import * as React from 'react'
import injectSheet from 'react-jss'
import {url} from '../../App/AuthenticatedRoute'
import {OrderFilterContainer} from '../../Components/OrderFiltering/OrderFilteringView'
import * as ClientSidePagination from '../../Data/ClientSidePagination'
import {httpErrorToMessage} from '../../Data/Http'
import {OptionalWebData} from '../../Data/OptionalWebData'
import {OrderExportOptions} from '../../Data/OrderExportOptions'
import {
    CompactPreviewOrderRow,
    DetailedPreviewOrderRow,
    DetailedPreviewPositionRow,
    OrderExportPreview
} from '../../Data/OrderExportPreview'
import {singleColors} from '../../Style'
import {ClientSidePaginationView} from '../../View/ClientSidePaginationView'
import {WithClasses} from '../../View/Helper'
import {MenuAndUpButton} from '../../View/MenuAndUpButton'
import {OrderExportCreateAction} from './OrderExportCreateActions'
import {LastExport, OrderExportCreateState} from './OrderExportCreateState'

interface Props {
    readonly state: OrderExportCreateState,
    readonly dispatch: (action: OrderExportCreateAction) => void,
}

const styles = {
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    overviewWrapper: {
        overflowY: 'scroll',
        flex: '1'
    },
    infoText: {
        padding: '32px 40px',
        backgroundColor: singleColors.gray
    },
    infoTextSuccess: {
        adding: '32px 40px',
    },
    infoTextError: {
        adding: '32px 40px',
    },
    fullWidth: {
        flex: '1',
    }
}

export const OrderExportCreateView =
    injectSheet<Props>(styles)(
        ({classes, state, dispatch}) => (
            <div className={`order-export ${classes.root}`}>
                <div className="navigation">
                    <AppBar
                        title="Neuer Auftragsexport"
                        className="navigation__bar"
                        iconElementLeft={
                            <MenuAndUpButton
                                onMenuButtonClicked={
                                    () => dispatch({type: 'MenuButtonClicked'})}
                                upUrl={url({type: 'OrderExportOverview'})}
                            />
                        }
                    />
                </div>
                <ContentView
                    classes={classes}
                    state={state}
                    dispatch={dispatch}
                />
            </div>
        )
    )

class ContentView
    extends React.Component<WithClasses<Props>, {
        filterPopoverAnchorElement?: HTMLElement,
    }> {
    constructor(props: WithClasses<Props>) {
        super(props)
        this.state = {}
    }

    render() {
        const {classes, state, dispatch} = this.props
        const
            {options, exportPreview, itemsPerPage} =
                state
        return (
            <div className={classes.exportWrapper}>
                <div className={classes.row}>
                    <Card className="card">
                        <div className="card__header">
                            Gewünschte Daten auswählen
                        </div>
                        <div className="card__content">
                            <OptionsView
                                options={options}
                                dispatch={dispatch}
                            />
                        </div>
                    </Card>
                    <div>

                        <Card className="card">
                            <div className="card__content">
                                <div className="export-buttons">
                                    <ExportButtons
                                        state={state}
                                        dispatch={dispatch}
                                    />
                                </div>
                                <OrderFilterContainer
                                    state={state.orderFilter}
                                    dispatch={
                                        subAction => dispatch({
                                            type: 'OrderFilteringModuleAction',
                                            subAction,
                                        })
                                    }
                                />
                                <div className="order-export__table">
                                    <PreviewView
                                        exportPreview={exportPreview}
                                        itemsPerPage={itemsPerPage}
                                        dispatch={dispatch}
                                        classes={classes}
                                    />
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        )
    }
}

function OptionsView({options, dispatch}: {
    options: OrderExportOptions,
    dispatch: (action: OrderExportCreateAction) => void,
}) {
    return (
        <div className="data-filter">
            <Checkbox
                className="data-filter__checkbox"
                label="Druckdaten"
                checked={options.has('PrintData')}
                onCheck={
                    (event, checked: boolean) => dispatch({
                        type: 'OptionChanged',
                        option: 'PrintData',
                        checked,
                    })
                }
            />
            <Checkbox
                className="data-filter__checkbox"
                label="UPS-CSV"
                checked={options.has('UpsCsv')}
                onCheck={
                    (event, checked: boolean) => dispatch({
                        type: 'OptionChanged',
                        option: 'UpsCsv',
                        checked,
                    })
                }
            />
            <Checkbox
                className="data-filter__checkbox"
                label="DMS-CSV"
                checked={options.has('DmsCsv')}
                onCheck={
                    (event, checked: boolean) => dispatch({
                        type: 'OptionChanged',
                        option: 'DmsCsv',
                        checked,
                    })
                }
            />
            <Checkbox
                className="data-filter__checkbox"
                label="Lieferscheine"
                checked={options.has('DeliveryNotes')}
                onCheck={
                    (event, checked: boolean) => dispatch({
                        type: 'OptionChanged',
                        option: 'DeliveryNotes',
                        checked,
                    })
                }
            />
            <Checkbox
                className="data-filter__checkbox"
                label="Rechnungen"
                checked={options.has('Invoices')}
                onCheck={
                    (event, checked: boolean) => dispatch({
                        type: 'OptionChanged',
                        option: 'Invoices',
                        checked,
                    })
                }
            />
            <Checkbox
                className="data-filter__checkbox"
                label="Auftragsblätter"
                checked={options.has('JobSheets')}
                onCheck={
                    (event, checked: boolean) => dispatch({
                        type: 'OptionChanged',
                        option: 'JobSheets',
                        checked,
                    })
                }
            />
        </div>
    )
}

interface ExportButtonsProps {
    state: OrderExportCreateState,
    dispatch: (action: OrderExportCreateAction) => void,
}

export const ExportButtons =
    injectSheet<ExportButtonsProps>(styles)(
        ({classes, state, dispatch}) => {
            return (
                <div className={classes.fullWidth}>
                    <RaisedButton
                        label="Abfragen"
                        disabled={state.loadingPreview}
                        onTouchTap={() => dispatch({type: 'FetchPreview'})}
                        icon={<NotificationSync/>}
                        style={{marginRight: '16px'}}
                        primary={state.inputChanged}
                    />
                    <RaisedButton
                        label="Export anfordern"
                        disabled={
                            state.loadingPreview ||
                            state.inputChanged ||
                            state.exportPreview.type !== 'Success' ||
                            state.lastExport.type === 'Loading'
                        }
                        onTouchTap={() => dispatch({type: 'CreateExport'})}
                        icon={<ContentAdd/>}
                    />
                    <LastExportView
                        lastExport={state.lastExport}
                        dispatch={dispatch}
                    />
                </div>
            )
        }
    )

interface LastExportProps {
    lastExport: OptionalWebData<LastExport>,
    dispatch: (action: OrderExportCreateAction) => void,
}

export const LastExportView =
    injectSheet<LastExportProps>(styles)(
        ({classes, lastExport, dispatch}) => {
            switch (lastExport.type) {
                case 'NotAsked':
                    return <span/>
                case 'Loading':
                    return (
                        <p className={classes.infoTextwarning}>
                            Export wird generiert...
                        </p>
                    )
                case 'Success':
                    const {orderExport, download} = lastExport.value
                    return (
                        <div>
                            <p className={classes.infoTextsuccess}>
                                Export #{orderExport.id} wurde heruntergeladen
                            </p>
                            <RaisedButton
                                label="Erneut herunterladen"
                                icon={
                                    (() => {
                                        switch (download.type) {
                                            case 'Default':
                                                return <FileFileDownload/>
                                            case 'Loading':
                                                return <CircularProgress size={24}/>
                                            case 'Failure':
                                                return <AlertError/>
                                        }
                                    })()
                                }
                                disabled={download.type === 'Loading'}
                                onTouchTap={() => dispatch({type: 'DownloadOrderExport'})}
                            />
                        </div>
                    )
                case 'Failure':
                    return <p>{httpErrorToMessage(lastExport.error)}</p>

            }
        }
    )

interface PreviewViewProps {
    readonly exportPreview: OptionalWebData<OrderExportPreview>,
    readonly itemsPerPage: number,
    readonly dispatch: (action: OrderExportCreateAction) => void,
}

class PreviewView
    extends React.Component<WithClasses<PreviewViewProps>, {}> {
    constructor(props: WithClasses<PreviewViewProps>) {
        super(props)
        this.state = {}
    }

    render() {
        const {classes, exportPreview, itemsPerPage, dispatch} = this.props
        switch (exportPreview.type) {
            case 'NotAsked':
                return <p className={classes.infoText}>Noch nichts abgefragt</p>
            case 'Loading':
                return <p className={classes.infoText}>Lädt...</p>
            case 'Success':
                return (() => {
                    switch (exportPreview.value.type) {
                        case 'CompactPreview':
                            return (
                                <CompactPreviewView
                                    itemsPerPage={itemsPerPage}
                                    pagination={exportPreview.value.orderRows}
                                    dispatch={dispatch}
                                />
                            )
                        case 'DetailedPreview':
                            return (
                                <DetailedPreviewView
                                    itemsPerPage={itemsPerPage}
                                    pagination={exportPreview.value.orderRows}
                                    dispatch={dispatch}
                                />
                            )
                    }
                })()
            case 'Failure':
                return <p>{httpErrorToMessage(exportPreview.error)}</p>
        }
    }

    shouldComponentUpdate(nextProps: PreviewViewProps, nextState: {}): boolean {
        return this.props.exportPreview !== nextProps.exportPreview
    }
}

function CompactPreviewView({itemsPerPage, pagination, dispatch}: {
    itemsPerPage: number,
    pagination: ClientSidePagination.ClientSidePagination<CompactPreviewOrderRow>,
    dispatch: (action: OrderExportCreateAction) => void,
}) {
    return (
        <div>
            <ResultCountDisplay
                pagination={pagination}
            />
            <ClientSidePaginationView
                itemsPerPage={itemsPerPage}
                pagination={pagination}
                onPrevious={() => dispatch({type: 'GoToPreviousPage'})}
                onNext={() => dispatch({type: 'GoToNextPage'})}
            />
            <Table
                multiSelectable={true}
                onRowSelection={
                    (selected: number[] | 'all') => dispatch({
                        type: 'CompactPreviewSelectionChanged',
                        selected,
                    })
                }
            >
                <TableHeader>
                    <TableRow>
                        <TableHeaderColumn>
                            Bestellnummer
                        </TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody
                    deselectOnClickaway={false}
                >
                    {R.map(
                        ({orderWithOwners, selected}) =>
                            <TableRow
                                selected={selected}
                                key={orderWithOwners.order.id}
                            >
                                <TableRowColumn>
                                    {orderWithOwners.order.orderNumber}
                                </TableRowColumn>
                            </TableRow>,
                        ClientSidePagination.slice(itemsPerPage, pagination),
                    )}
                </TableBody>
            </Table>
        </div>
    )
}

function DetailedPreviewView({itemsPerPage, pagination, dispatch}: {
    itemsPerPage: number,
    pagination: ClientSidePagination.ClientSidePagination<DetailedPreviewOrderRow>,
    dispatch: (action: OrderExportCreateAction) => void,
}) {
    return (
        <div>
            <ResultCountDisplay
                pagination={pagination}
            />
            <ClientSidePaginationView
                itemsPerPage={itemsPerPage}
                pagination={pagination}
                onPrevious={() => dispatch({type: 'GoToPreviousPage'})}
                onNext={() => dispatch({type: 'GoToNextPage'})}
            />
            <Table>
                <TableHeader
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                >
                    <TableHeaderColumn>
                        Bestellnummer
                    </TableHeaderColumn>
                    <TableHeaderColumn>
                        Name
                    </TableHeaderColumn>
                </TableHeader>
                <TableBody
                    deselectOnClickaway={false}
                    displayRowCheckbox={false}
                >
                    {R.map(
                        orderRow => {
                            const
                                {orderWithOwners, positionRows} =
                                    orderRow,

                                rowSpan = {rowSpan: R.length(positionRows)}
                            return R.prepend(
                                <TableRow
                                    key={`order-${orderWithOwners.order.id}`}
                                >
                                    <TableRowColumn {...rowSpan}>
                                        <Checkbox
                                            label={orderWithOwners.order.orderNumber}
                                            checked={orderRow.selected}
                                            onCheck={
                                                (
                                                    event,
                                                    checked: boolean
                                                ) => dispatch({
                                                    type: 'DetailedPreviewOrderSelectedChanged',
                                                    id: orderWithOwners.order.id,
                                                    checked,
                                                })
                                            }
                                        />
                                    </TableRowColumn>
                                    {DetailedPreviewPositionRowView({
                                        orderId: orderWithOwners.order.id,
                                        positionRow: positionRows[0],
                                        dispatch,
                                    })}
                                </TableRow>,
                                R.map(
                                    positionRow =>
                                        <TableRow
                                            key={`position-${positionRow.position.id}`}
                                        >
                                            {DetailedPreviewPositionRowView({
                                                orderId: orderWithOwners.order.id,
                                                positionRow,
                                                dispatch,
                                            })}
                                        </TableRow>,
                                    R.drop(1, positionRows),
                                ),
                            )
                        },
                        ClientSidePagination.slice(itemsPerPage, pagination),
                    )}
                </TableBody>
            </Table>
        </div>
    )
}

function DetailedPreviewPositionRowView({orderId, positionRow, dispatch}: {
    orderId: number,
    positionRow: DetailedPreviewPositionRow,
    dispatch: (action: OrderExportCreateAction) => void,
}) {
    return [
        (
            <TableRowColumn>
                <Checkbox
                    label={positionRow.position.name}
                    checked={positionRow.selected}
                    onCheck={
                        (event, checked: boolean) => dispatch({
                            type: 'DetailedPreviewPositionSelectedChanged',
                            orderId,
                            id: positionRow.position.id,
                            checked,
                        })
                    }
                />
            </TableRowColumn>
        ),
    ]
}

function ResultCountDisplay<T>({pagination}: {
    pagination: ClientSidePagination.ClientSidePagination<T>,
}) {
    if (pagination.totalRemoteCount > pagination.items.length) {
        return (
            <span>
                Von {pagination.totalRemoteCount} Ergebnissen können nur die
                ersten {pagination.items.length} Aufträge exportiert werden.
            </span>
        )
    } else {
        return (
            <span>{pagination.items.length} Aufträge</span>
        )
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/OrderExportCreate/OrderExportCreateView.tsx